import { Injectable } from '@angular/core'

import { ApiService } from '../common/api.service'
import { HttpObjectService } from '../common/http-object.service'

@Injectable()

export class CompanyService extends HttpObjectService {
  object = 'company'

  constructor(public apiService: ApiService) {
    super(apiService)
  }
}
